;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="c7c47d56-b262-4706-afc1-3c14f19446ea",e._sentryDebugIdIdentifier="sentry-dbid-c7c47d56-b262-4706-afc1-3c14f19446ea")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8105],{

/***/ 39434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oM": function() { return /* binding */ isSmartCollectionInputWithSlug; }
/* harmony export */ });
/* unused harmony exports isSmartCollectionResponse, isOnlyFoodTypesInput */
var CHECK_KEY = "slug";
/**
 * Assert function for SmartCollectionResponse
 */ function isSmartCollectionResponse(input) {
    return typeof input === "object" && input !== null && CHECK_KEY in input;
}
/** Assert function for SmartCollectionInputWithSlug */ function isSmartCollectionInputWithSlug(input) {
    return input.slug !== undefined;
}
/** Type guard function to check if input has only 'food_types' */ var isOnlyFoodTypesInput = function(input) {
    return typeof input === "object" && input !== null && Object.keys(input).length === 1 && "food_types" in input;
};


/***/ }),

/***/ 93615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CollectionSorting; }
/* harmony export */ });
/* unused harmony export quickLinks */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67573);
/* provided dependency */ var process = __webpack_require__(83454);

var CollectionSorting;
(function(CollectionSorting) {
    CollectionSorting["DEFAULT"] = "COLLECTION_DEFAULT";
    CollectionSorting["TITLE"] = "title";
    CollectionSorting["PRICE_ASCENDING"] = "price-ascending";
    CollectionSorting["PRICE_DESCENDING"] = "price-descending";
    CollectionSorting["NEW"] = "new";
    CollectionSorting["BEST_SELLING"] = "best-selling";
})(CollectionSorting || (CollectionSorting = {}));
var _obj;
var quickLinks = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "".concat("fur-hunde"), [
    {
        value: "fur-hunde-nassfutter",
        label: "Nassfutter",
        src: "PD-CDP-Quickmenu-Hund-NaFu.jpg"
    },
    {
        value: "fur-hunde-barf-frische-menus",
        label: "BARF-Menüs",
        src: "PD-CDP-Quickmenu-Hund-BARF.jpg"
    },
    {
        value: "fur-hunde-trockenfutter",
        label: "Trockenfutter",
        src: "PD-CDP-Quickmenu-Hund-TroFu.jpg"
    },
    {
        value: "fur-hunde-green",
        label: "Green",
        src: "PD-CDP-Quickmenu-Hund-Green.jpg"
    },
    {
        value: "fur-hunde-nahrungserganzung",
        label: "Nahrungsergänzung",
        src: "PD-CDP-Quickmenu-Hund-Supplementa.jpg"
    },
    {
        value: process.env.FOR_DOGS_HEALTY_2,
        label: "Gesundheit",
        src: "PD-CDP-Quickmenu-Hund-Gesundheit.jpg"
    },
    {
        value: "fur-hunde-bundles",
        label: "Vorteilspakete",
        src: "PD-CDP-Quickmenu-Hund-Probierpakete.jpg"
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, "".concat("fur-katzen"), [
    {
        value: "fur-katzen-nassfutter",
        label: "Nassfutter",
        src: "PD-CDP-Quickmenu-Katze-NaFu.jpg"
    },
    {
        value: "fur-katzen-barf-frische-menus",
        label: "BARF-Menüs",
        src: "PD-CDP-Quickmenu-Katze-BARF.jpg"
    },
    {
        value: "fur-katzen-trockenfutter",
        label: "Trockenfutter",
        src: "PD-CDP-Quickmenu-Katze-TroFu.jpg"
    },
    {
        value: "fur-katzen-snacks",
        label: "Snacks",
        src: "PD-CDP-Quickmenu-Katze-Snacks.jpg"
    },
    {
        value: "fur-katzen-nahrungserganzung",
        label: "Nahrungsergänzung",
        src: "PD-CDP-Quickmenu-Katze-Supplementa.jpg"
    },
    {
        value: "fur-katzen-bundles",
        label: "Vorteilspakete",
        src: "PD-CDP-Quickmenu-Katze-Probierpakete.jpg"
    }, 
]), _obj);


/***/ }),

/***/ 86027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ transformCollection; }
});

// UNUSED EXPORTS: Collection

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(75815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/product/getSmartColleciton/utils/index.ts
var utils = __webpack_require__(99108);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/models/collection/collection.tsx + 1 modules
var collection_collection = __webpack_require__(45991);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./src/constants/shop.ts
var shop = __webpack_require__(72502);
// EXTERNAL MODULE: ./src/models/collection/constants/cat-general-cdp/index.ts
var cat_general_cdp = __webpack_require__(36602);
// EXTERNAL MODULE: ./src/models/collection/constants/dog-general-cdp/index.ts
var dog_general_cdp = __webpack_require__(75611);
;// CONCATENATED MODULE: ./src/models/collection/utils/shouldIgnoreSubtitle/index.ts




/**
 * Due to data availability, CH shop ignores dog general pages too
 */ var HANDLES = (0,_to_consumable_array/* default */.Z)(Object.values(cat_general_cdp/* CatGeneralCdpHandle */.Q)).concat((0,_to_consumable_array/* default */.Z)("DE" === shop/* ShopId.CH */.w.CH ? Object.values(dog_general_cdp/* DogGeneralCdpHandle */.l) : []));
/**
 * Quick fix for cat personalization title.
 * we ignore specific food type cdp
 */ var shouldIgnoreSubtitle = function(param) {
    var handle = param.handle;
    if (!handle) return false;
    return HANDLES.includes(handle);
};
/* harmony default export */ var utils_shouldIgnoreSubtitle = (shouldIgnoreSubtitle);

;// CONCATENATED MODULE: ./src/models/collection/transformCollection.tsx






var transformCollection = function(param) {
    var title = param.title, collection = param.collection;
    var handle = (0,utils/* isSmartCollectionResponse */.A)(collection) ? collection.slug : undefined;
    return new Collection({
        title: title,
        collection: collection,
        shouldIgnoreSubtitle: utils_shouldIgnoreSubtitle({
            handle: handle
        })
    });
};
var Collection = function Collection(param) {
    "use strict";
    var title = param.title, collection = param.collection, _shouldIgnoreSubtitle = param.shouldIgnoreSubtitle, shouldIgnoreSubtitle = _shouldIgnoreSubtitle === void 0 ? false : _shouldIgnoreSubtitle;
    var _this = this;
    (0,_class_call_check/* default */.Z)(this, Collection);
    this.getBestSellerTitle = function(param) {
        var segmentation = param.segmentation;
        if (_this.bestSellerTitle) {
            return _this.bestSellerTitle;
        }
        if (segmentation) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "personalized-ribbon-".concat(segmentation),
                values: {
                    b: function(chunks) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: chunks
                        });
                    }
                }
            });
        }
        return null;
    };
    this.products = ((0,utils/* isSmartCollectionResponse */.A)(collection) ? collection.items : collection.products).map(function(product) {
        return new collection_collection/* CollectionProduct */.Y(product, shouldIgnoreSubtitle);
    });
    if ((0,utils/* isSmartCollectionResponse */.A)(collection)) {
        this.bestSellerTitle = collection.title;
        this.endlessCdpTitle = collection.endless_title || collection.title || title;
    } else {
        this.endlessCdpTitle = title || collection.title;
    }
    this.title = title || collection.title;
};


/***/ }),

/***/ 95961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WH": function() { return /* binding */ CollectionContext; },
  "YQ": function() { return /* binding */ CollectionProvider; },
  "IO": function() { return /* binding */ useCollectionState; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/product/getSmartColleciton/types/index.ts
var types = __webpack_require__(39434);
// EXTERNAL MODULE: ./src/constants/collection.ts
var constants_collection = __webpack_require__(93615);
// EXTERNAL MODULE: ./src/constants/product.ts
var product = __webpack_require__(42421);
// EXTERNAL MODULE: ./src/constants/segmentation.ts
var constants_segmentation = __webpack_require__(6813);
// EXTERNAL MODULE: ./src/contexts/pet.tsx
var pet = __webpack_require__(75556);
// EXTERNAL MODULE: ./src/contexts/segmentation.tsx + 3 modules
var contexts_segmentation = __webpack_require__(42067);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/models/collection/transformCollection.tsx + 1 modules
var transformCollection = __webpack_require__(86027);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(92918);
;// CONCATENATED MODULE: ./src/modules/collection/hooks/use-apply-filter-from-url/index.tsx


/**
 * Apply filter values via url params.
 */ var useApplyFilterFromUrl = function(param) {
    var setAppliedFilter = param.setAppliedFilter, isReady = param.isReady, targetQuery = param.targetQuery;
    (0,react.useEffect)(function() {
        if (!isReady) return;
        var filterStr = Array.isArray(targetQuery) ? targetQuery[1] : null;
        if (filterStr) {
            setAppliedFilter(filterStr.split("+").map(function(tag) {
                return (0,strings/* slugify */.lV)(tag);
            }));
        } else {
            setAppliedFilter([]);
        }
    }, [
        isReady,
        setAppliedFilter,
        targetQuery
    ]);
};
/* harmony default export */ var use_apply_filter_from_url = (useApplyFilterFromUrl);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/api/judge-me.ts
var judge_me = __webpack_require__(60925);
// EXTERNAL MODULE: ./src/api/middleware/laggy.ts
var laggy = __webpack_require__(39143);
// EXTERNAL MODULE: ./src/api/product.ts
var api_product = __webpack_require__(94070);
// EXTERNAL MODULE: ./src/api/product/getSmartColleciton/utils/index.ts
var utils = __webpack_require__(99108);
// EXTERNAL MODULE: ./src/stores/reviews-cache.ts
var reviews_cache = __webpack_require__(32889);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/utils/judge-me.ts
var utils_judge_me = __webpack_require__(8181);
;// CONCATENATED MODULE: ./src/modules/collection/hooks/use-judge-me-reviews.tsx











/**
 * Hook to fetch judgeMe review badge information of products in Collections
 */ var useJudgeMeReviews = function(param) {
    var collection = param.collection, segmentation = param.segmentation;
    var swrKey = (0,react.useMemo)(function() {
        if (!collection) return "";
        if ((0,api_product/* isLegacyCollection */.ym)(collection)) {
            return collection.handle;
        } else if (segmentation) {
            return typeof segmentation === "string" ? segmentation : Object.values(segmentation).flat();
        }
        return collection.slug;
    }, [
        collection,
        segmentation
    ]);
    var setReviews = (0,reviews_cache/* useReviewsCacheStore */.g)().setReviews;
    var productIds = (0,react.useMemo)(function() {
        if (!collection) return [];
        return (0,utils/* isSmartCollectionResponse */.A)(collection) ? collection.items.map(function(item) {
            return item.product_id;
        }) : collection.products.map(function(product) {
            return product.id.toString();
        });
    }, [
        collection
    ]);
    var ref = (0,dist/* default */.ZP)("judge-me-".concat(swrKey), /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var rawReviews, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!productIds.length) return [
                        2,
                        undefined
                    ];
                    _tmp = {};
                    return [
                        4,
                        (0,judge_me/* getJudgeMeRatings */.U)((_tmp.externalIds = productIds, _tmp))
                    ];
                case 1:
                    rawReviews = _state.sent();
                    if (!rawReviews) return [
                        2,
                        undefined
                    ];
                    _tmp1 = {};
                    return [
                        2,
                        (0,utils_judge_me/* parseReviews */.m)((_tmp1.rawReviews = rawReviews, _tmp1))
                    ];
            }
        });
    }), {
        use: [
            laggy/* default */.Z
        ],
        revalidateOnMount: false,
        onSuccess: function(data) {
            if (!data) return;
            setReviews(function(prev) {
                return (0,_object_spread/* default */.Z)({}, prev, data);
            });
        }
    }), data = ref.data, isValidating = ref.isValidating, mutate = ref.mutate;
    (0,react.useEffect)(function() {
        if (collection) {
            mutate();
        }
    }, [
        collection,
        mutate
    ]);
    return {
        data: data,
        isLoading: isValidating
    };
};
/* harmony default export */ var use_judge_me_reviews = (useJudgeMeReviews);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_property_key.mjs + 1 modules
var _to_property_key = __webpack_require__(67708);
;// CONCATENATED MODULE: ./src/modules/collection/hooks/use-request-url-update/index.tsx




/**
 * Request url update by filter name
 */ var useRequestUrlUpdate = function(param) {
    var baseUri = param.baseUri, _excludeKey = param.excludeKey, excludeKey = _excludeKey === void 0 ? "" : _excludeKey;
    var ref = (0,next_router.useRouter)(), replace = ref.replace, query = ref.query;
    var requestURLUpdate = (0,react.useCallback)(function(filters) {
        if (!baseUri) return;
        var filtersPathPart = filters.length > 0 ? filters.join("+") : "";
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _ = query[excludeKey], others = (0,_object_without_properties/* default */.Z)(query, [
            excludeKey
        ].map(_to_property_key/* default */.Z));
        replace({
            pathname: "".concat(baseUri, "/").concat(filtersPathPart),
            query: others
        }, undefined, {
            shallow: true
        });
    }, [
        baseUri,
        excludeKey,
        query,
        replace
    ]);
    return {
        requestURLUpdate: requestURLUpdate
    };
};
/* harmony default export */ var use_request_url_update = (useRequestUrlUpdate);

// EXTERNAL MODULE: ./src/contexts/ninetailed-ab-test.tsx + 1 modules
var ninetailed_ab_test = __webpack_require__(84947);
// EXTERNAL MODULE: ./src/contexts/tracking.tsx + 1 modules
var tracking = __webpack_require__(70315);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./src/api/product/getSmartColleciton/index.ts
var getSmartColleciton = __webpack_require__(29244);
// EXTERNAL MODULE: ./src/constants/feature-flag.ts
var feature_flag = __webpack_require__(93841);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/modules/collection/hooks/use-collection-fetch/index.tsx










var featureFlg = (0,feature_flag/* getFeatureFlag */.O)(feature_flag/* FeatureFlag.smartCollectionEndpoint */.T.smartCollectionEndpoint);
var useCollectionFetch = function(param) {
    var collectionDefault = param.collectionDefault, swrOptions = param.swrOptions, collectionHandle = param.collectionHandle, segmentation = param.segmentation, smartCollectionInput = param.smartCollectionInput, ninetailed = param.ninetailed;
    var ref = (0,react.useState)(collectionDefault), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    // Ref to store the latest ninetailed value after debounce
    var debouncedNinetailed = (0,react.useRef)(ninetailed);
    var debounceNinetailedUpdate = (0,lodash.debounce)(function(value) {
        debouncedNinetailed.current = value;
    }, 500);
    (0,react.useEffect)(function() {
        debounceNinetailedUpdate(ninetailed);
    }, [
        ninetailed,
        debounceNinetailedUpdate
    ]);
    /**
   * Refetch Data on client side so we always get updated data
   */ var isValidating = (0,dist/* default */.ZP)(function() {
        return [
            collectionHandle,
            segmentation,
            smartCollectionInput,
            debouncedNinetailed.current, 
        ];
    }, function(collectionHandle, segmentation, smartCollectionInput, ninetailed) {
        setIsLoading(true);
        if (!collectionHandle && !segmentation && !smartCollectionInput) {
            throw new Error("no handle and segmentation is assigned");
        }
        if (smartCollectionInput) {
            return (0,getSmartColleciton/* getSmartCollection */.A)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, smartCollectionInput), {
                ninetailed: ninetailed
            }));
        }
        if (collectionHandle) {
            return (0,getSmartColleciton/* getSmartCollection */.A)(collectionHandle, true);
        }
        throw new Error("no handle and segmentation is assigned");
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fallback: (0,_object_spread/* default */.Z)({}, collectionHandle ? (0,_define_property/* default */.Z)({}, collectionHandle, collectionDefault) : {}),
        use: [
            laggy/* default */.Z
        ]
    }, swrOptions), {
        onSuccess: function(data) {
            // For CH we return the data as CollectionResponse.
            if (!featureFlg) setData(data);
            // On some cases where collection import is not done correctly, we show default collection as fall back
            if ((0,utils/* isSmartCollectionResponse */.A)(data) && data.items.length > 0) {
                setData(data);
            // And in other cases the fallback is undefined, since collectionDefault could be undefined as well.
            // In this event, we return the data as CollectionResponse.
            } else if (!collectionDefault && !(0,utils/* isSmartCollectionResponse */.A)(data)) {
                setData(data);
            }
            setIsLoading(false);
        }
    })).isValidating;
    return {
        data: data,
        isLoading: isLoading || isValidating
    };
};
/* harmony default export */ var use_collection_fetch = (useCollectionFetch);

// EXTERNAL MODULE: ./src/modules/collection/utils/get-all-filter/index.tsx
var get_all_filter = __webpack_require__(57359);
// EXTERNAL MODULE: ./src/modules/collection/utils/modify-config/const.ts
var modify_config_const = __webpack_require__(71033);
// EXTERNAL MODULE: ./src/modules/collection/state/visible-products.ts
var visible_products = __webpack_require__(85556);
;// CONCATENATED MODULE: ./src/modules/collection/state/index.tsx

























var CollectionContext = /*#__PURE__*/ react.createContext({});
/**
 * Map of filter to segmentation
 */ var SEGMENTS_FILTER_MAP = {
    "bestimmte-erkrankung": "disease",
    "haut-and-fellprobleme": "skin-fur",
    "sehr-wahlerisch": [
        constants_segmentation/* SegmentationIds.PickyEater */.f0.PickyEater,
        constants_segmentation/* SegmentationIds.CatPickyEater */.f0.CatPickyEater, 
    ],
    "senior-7-jahre": "senior",
    "unvertraglichkeiten-allergien": "intolerance",
    verdauungsprobleme: [
        constants_segmentation/* SegmentationIds.Digestion */.f0.Digestion,
        constants_segmentation/* SegmentationIds.CatDigestion */.f0.CatDigestion
    ],
    welpe: "welpe",
    ubergewicht: [
        constants_segmentation/* SegmentationIds.Overweight */.f0.Overweight,
        constants_segmentation/* SegmentationIds.CatOverweight */.f0.CatOverweight
    ],
    steriliziert: constants_segmentation/* SegmentationIds.Sterilized */.f0.Sterilized,
    freiganger: constants_segmentation/* SegmentationIds.Outdoor */.f0.Outdoor,
    kitten: constants_segmentation/* SegmentationIds.Kitten */.f0.Kitten,
    senior: constants_segmentation/* SegmentationIds.CatSenior */.f0.CatSenior
};
/**
 * Filter value set for segmentation
 */ var SEGMENT_FILTERS_SET = new Set(Object.keys(SEGMENTS_FILTER_MAP));
var sortCollection = function(collection, sorting) {
    var sortedProducts = collection.products;
    if (sorting === constants_collection/* CollectionSorting.TITLE */.I.TITLE) {
        sortedProducts = orderBy_default()(collection.products, function(product) {
            return product.title.trim();
        }, "asc");
    }
    if ([
        constants_collection/* CollectionSorting.PRICE_ASCENDING */.I.PRICE_ASCENDING,
        constants_collection/* CollectionSorting.PRICE_DESCENDING */.I.PRICE_DESCENDING, 
    ].includes(sorting)) {
        sortedProducts = orderBy_default()(collection.products, function(product) {
            return parseFloat(product.variants[0].priceV2.amount);
        }, sorting === constants_collection/* CollectionSorting.PRICE_ASCENDING */.I.PRICE_ASCENDING ? "asc" : "desc");
    }
    if (sorting === constants_collection/* CollectionSorting.NEW */.I.NEW) {
        sortedProducts = orderBy_default()(collection.products, function(product) {
            return new Date(product.createdAt);
        }, "asc");
    }
    if (sorting === constants_collection/* CollectionSorting.BEST_SELLING */.I.BEST_SELLING) {
        sortedProducts = orderBy_default()(collection.products, function() {
            return 0;
        }, "asc");
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
        products: sortedProducts
    });
};
/**
 * Collection Context provider.
 * Filter values should be updated via only url updates.
 * so that always the flow is streamlined in url -> appliedFilter.
 *
 * This context accepts either collection handle, segmentation store or dynamic collection input
 *
 * @TODO : trackingListName is provisional implementation. waiting the answer from chris
 */ var CollectionProvider = function(_param) {
    var children = _param.children, tmp = _param.tags, initialTags = tmp === void 0 ? [] : tmp, collectionDefault = _param.collection, sortBy = _param.sortBy, _swrOptions = _param.swrOptions, swrOptions = _swrOptions === void 0 ? {} : _swrOptions, trackingListName = _param.trackingListName, setUsedTags = _param.setUsedTags, applyPetProfile = _param.applyPetProfile, others = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "tags",
        "collection",
        "sortBy",
        "swrOptions",
        "trackingListName",
        "setUsedTags",
        "applyPetProfile"
    ]);
    var segmentation = others.segmentation, collectionHandle = others.collectionHandle, smartCollectionInput = others.smartCollectionInput;
    var experimentHeaderStr = (0,ninetailed_ab_test/* useNinetailedAbTestContext */.R)().experimentHeaderStr;
    var ref = use_collection_fetch((0,_object_spread/* default */.Z)({
        collectionDefault: collectionDefault,
        swrOptions: swrOptions,
        ninetailed: experimentHeaderStr === null || experimentHeaderStr === void 0 ? void 0 : experimentHeaderStr.split(",")
    }, others)), data = ref.data, isLoading = ref.isLoading;
    var trackHotjarEvent = (0,tracking/* useTrackingContext */.E)().trackHotjarEvent;
    var current = (0,pet/* usePetContext */.w)().current;
    var router = (0,next_router.useRouter)();
    var isCDP = (0,react.useMemo)(function() {
        return router.pathname === "/collections/[...all]";
    }, [
        router.pathname
    ]);
    var ref1 = (0,contexts_segmentation/* useSegmentationContext */.M)(), _segmentation = ref1.segmentation, shouldOmitPersonalization = ref1.shouldOmitPersonalization, pushSegmentation = ref1.pushSegmentation;
    var ref2 = (0,react.useState)(), limitOfProductsToShow = ref2[0], setLimitOfProductsToShow = ref2[1];
    use_judge_me_reviews({
        collection: data,
        segmentation: segmentation
    });
    var transformedCollection = react.useMemo(function() {
        if (!data) {
            return (0,transformCollection/* transformCollection */.Z)({
                title: "",
                collection: {
                    title: "",
                    products: []
                }
            });
        }
        return (0,transformCollection/* transformCollection */.Z)({
            collection: data
        });
    }, [
        data
    ]);
    var petType = (0,react.useMemo)(function() {
        var isDog = transformedCollection.products.some(function(p) {
            return p.tags.indexOf(product/* PetTag.Dog */.u.Dog) > -1;
        });
        return isDog ? "dog" : "cat";
    }, [
        transformedCollection.products
    ]);
    var filterConfig = (0,react.useMemo)(function() {
        var handle = collectionHandle;
        if (!handle && smartCollectionInput && (0,types/* isSmartCollectionInputWithSlug */.oM)(smartCollectionInput)) {
            handle = smartCollectionInput.slug;
        }
        // apply all available filters when handle is not available
        if (!handle) {
            return (0,get_all_filter/* default */.Z)({
                petType: petType
            });
        }
        return (0,modify_config_const/* modifyConfig */.oR)({
            filterConfig: (0,get_all_filter/* default */.Z)({
                petType: petType
            }),
            isPetProfileApplied: applyPetProfile,
            handle: handle
        });
    }, [
        applyPetProfile,
        collectionHandle,
        petType,
        smartCollectionInput, 
    ]);
    var ref3 = (0,react.useState)(constants_collection/* CollectionSorting.DEFAULT */.I.DEFAULT), sorting = ref3[0], setSorting = ref3[1];
    var collection = (0,react.useMemo)(function() {
        return sortCollection(transformedCollection, sorting);
    }, [
        transformedCollection,
        sorting
    ]);
    (0,react.useEffect)(function() {
        setSorting(sortBy || constants_collection/* CollectionSorting.DEFAULT */.I.DEFAULT);
    }, [
        sortBy,
        data
    ]);
    /**
   * Filter Logic
   */ var ref4 = (0,react.useState)(initialTags.map(function(tag) {
        return (0,strings/* slugify */.lV)(tag);
    })), appliedFilter = ref4[0], setAppliedFilter = ref4[1];
    var ref5 = (0,react.useState)([]), appliedAllergyFilter = ref5[0], setAppliedAllergyFilter = ref5[1];
    // Since the allregy filter also include a value that is toggled in the standard way,
    // we need to keep track of the active allergy filter separately.
    var ref6 = (0,react.useState)([]), activeAllergyFilter = ref6[0], setActiveAllergyFilter = ref6[1];
    var toggleActiveAllergyFilter = (0,react.useCallback)(function(value) {
        var newFilter = activeAllergyFilter.includes(value) ? activeAllergyFilter.filter(function(filter) {
            return filter !== value;
        }) : (0,_to_consumable_array/* default */.Z)(activeAllergyFilter).concat([
            value
        ]);
        setActiveAllergyFilter(newFilter);
    }, [
        activeAllergyFilter
    ]);
    /**
   * Apply filter values via url params.
   */ use_apply_filter_from_url({
        setAppliedFilter: setAppliedFilter,
        isReady: router.isReady,
        targetQuery: router.query["all"]
    });
    /** Propagate used tags to parent  */ (0,react.useEffect)(function() {
        if (setUsedTags) {
            setUsedTags((0,_to_consumable_array/* default */.Z)(appliedFilter));
        }
    }, [
        appliedFilter,
        setUsedTags
    ]);
    var visibleProducts = (0,visible_products/* useVisibleProductList */.c)({
        collection: collection,
        activeFilter: appliedFilter,
        activeAllergiesFilter: appliedAllergyFilter,
        filterConfig: filterConfig,
        segmentation: _segmentation,
        shouldOmitPersonalization: shouldOmitPersonalization
    });
    /**
   * Due to the time lag between url update and applied filter update,
   * applied filter are previous values even after url is updated.
   * so here, we reset values when it's a non-shallow route change
   * */ (0,react.useEffect)(function() {
        var handleRouteChange = function(url, param) {
            var shallow = param.shallow;
            if (!shallow) {
                setAppliedFilter([]);
            }
        };
        router.events.on("routeChangeStart", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router
    ]);
    var handle = (0,react.useMemo)(function() {
        try {
            if (collectionHandle) {
                return collectionHandle;
            }
            return router.isReady ? router.query.all[0] : undefined;
        } catch (error) {
            return undefined;
        }
    }, [
        collectionHandle,
        router.isReady,
        router.query.all
    ]);
    var requestURLUpdate = use_request_url_update({
        baseUri: "/collections/".concat(handle),
        excludeKey: "all"
    }).requestURLUpdate;
    var initialFilterClick = (0,react.useRef)(false);
    /**
   * Toggles a filter value and updates applied filters and segmentation.
   * Updates applied filters and segmentation based on whether the filter value is added or removed.
   * For Collection pages, it updates the URL; otherwise, it updates applied filters directly.
   */ var toggleFilter = (0,react.useCallback)(function(value) {
        var newFilter = appliedFilter.includes(value) ? appliedFilter.filter(function(filter) {
            return filter !== value;
        }) : (0,_to_consumable_array/* default */.Z)(appliedFilter).concat([
            value
        ]);
        initialFilterClick.current = true;
        isCDP ? requestURLUpdate(newFilter) : setAppliedFilter(newFilter);
    }, [
        appliedFilter,
        isCDP,
        requestURLUpdate
    ]);
    /**
   * Check logics here
   */ (0,react.useEffect)(function() {
        var filtered = appliedFilter.filter(function(v) {
            return SEGMENT_FILTERS_SET.has(v);
        });
        if (filtered.length > 0) {
            var segmentFilter = SEGMENTS_FILTER_MAP[filtered[filtered.length - 1]];
            if (typeof segmentFilter === "string") {
                trackHotjarEvent();
                pushSegmentation({
                    segmentation: segmentFilter
                });
            } else if (Array.isArray(segmentFilter) && current !== false) {
                var segmentation = segmentFilter.find(function(filter) {
                    if (current === "dogs") {
                        return !(0,constants_segmentation/* isCatSegmentation */.no)(filter);
                    } else {
                        return (0,constants_segmentation/* isCatSegmentation */.no)(filter);
                    }
                });
                segmentation && pushSegmentation({
                    segmentation: segmentation
                });
            }
        }
    }, [
        appliedFilter,
        collectionHandle,
        current,
        pushSegmentation
    ]);
    var toggleAllergyFilter = (0,react.useCallback)(function(value) {
        var newFilter = appliedAllergyFilter.includes(value) ? appliedAllergyFilter.filter(function(filter) {
            return filter !== value;
        }) : (0,_to_consumable_array/* default */.Z)(appliedAllergyFilter).concat([
            value
        ]);
        setAppliedAllergyFilter(newFilter);
    }, [
        appliedAllergyFilter
    ]);
    var resetFilter = (0,react.useCallback)(function() {
        isCDP ? requestURLUpdate([]) : setAppliedFilter([]);
        setActiveAllergyFilter([]);
        setAppliedAllergyFilter([]);
    }, [
        isCDP,
        requestURLUpdate
    ]);
    // If the products are not displayed in the CDP, we need to filter out the
    // Purpose boxes.
    var filteredVisibleProducts = (0,react.useMemo)(function() {
        return isCDP ? visibleProducts : visibleProducts.filter(function(product) {
            return !(product.tags.includes("Probierpaket") || product.tags.includes("Purpose Box") || product.tags.includes("Bundle"));
        });
    }, [
        isCDP,
        visibleProducts
    ]);
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionContext.Provider, {
        value: {
            activeAllergyFilter: activeAllergyFilter,
            appliedAllergyFilter: appliedAllergyFilter,
            appliedFilter: appliedFilter,
            collection: collection,
            filterConfig: filterConfig,
            isValidating: isLoading,
            limitOfProductsToShow: limitOfProductsToShow,
            sorting: sorting,
            visibleProducts: filteredVisibleProducts,
            resetFilter: resetFilter,
            setLimitOfProductsToShow: setLimitOfProductsToShow,
            toggleActiveAllergyFilter: toggleActiveAllergyFilter,
            toggleAllergyFilter: toggleAllergyFilter,
            toggleFilter: toggleFilter,
            productsLength: visibleProducts.length,
            trackingListName: (ref7 = trackingListName !== null && trackingListName !== void 0 ? trackingListName : handle) !== null && ref7 !== void 0 ? ref7 : "list not identified"
        },
        children: children
    });
};
/** Provide collection context  */ var useCollectionState = function() {
    return (0,react.useContext)(CollectionContext);
};


/***/ }),

/***/ 85556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useVisibleProductList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var utils_strings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92918);



var checkIfProductCorresponds = function(productTags, filterGroup, assignedFilter, config) {
    // if this filter group has no active filters, then it's okay to show
    if (!assignedFilter[filterGroup].length) return true;
    // AND Filter
    if (config[filterGroup].compare === "AND") {
        return assignedFilter[filterGroup].every(function(filter) {
            return productTags.includes(filter);
        });
    }
    // OR filter
    return assignedFilter[filterGroup].some(function(filter) {
        return productTags.includes(filter);
    });
};
var useVisibleProductList = function(param) {
    var collection = param.collection, activeFilter = param.activeFilter, activeAllergiesFilter = param.activeAllergiesFilter, filterConfig = param.filterConfig, segmentation = param.segmentation, shouldOmitPersonalization = param.shouldOmitPersonalization;
    // we need to slugify the tags
    var tagsMap = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        var map = {};
        if (!collection) {
            return map;
        }
        collection.products.forEach(function(product) {
            map[product.id] = product.tags.map(function(tag) {
                return (0,utils_strings__WEBPACK_IMPORTED_MODULE_1__/* .slugify */ .lV)(tag);
            });
        });
        return map;
    }, [
        collection
    ]);
    var visibleProducts = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        if (!collection || !collection.products) {
            return [];
        }
        if (!filterConfig) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(collection.products);
        }
        // creates an object with each filter group as key and the selected filters in this group as array
        var assignedFilter = {};
        Object.entries(filterConfig).map(function(filterGroup) {
            return assignedFilter[filterGroup[0]] = filterGroup[1].tags.filter(function(tag) {
                return activeFilter.includes(tag);
            });
        });
        // If the personalisation is enabled, we should sort the products by best seller,
        // in order to rank them on the top of the list.
        var sortedBestSellerProducts = shouldOmitPersonalization ? collection.products : collection.products.sort(function(a, b) {
            if (!a.availableForSale || !b.availableForSale) {
                return 0;
            }
            var isBestSellerA = a.getIsBestSeller({
                segment: segmentation
            });
            var isBestSellerB = b.getIsBestSeller({
                segment: segmentation
            });
            if (isBestSellerA && !isBestSellerB) return -1;
            if (!isBestSellerA && isBestSellerB) return 1;
            return 0;
        });
        var products = sortedBestSellerProducts.filter(function(product) {
            // Check if the product contains any tag from activeAllergiesFilter
            var hasAllergiesFilterTag = activeAllergiesFilter === null || activeAllergiesFilter === void 0 ? void 0 : activeAllergiesFilter.some(function(tag) {
                return tagsMap[product.id].includes((0,utils_strings__WEBPACK_IMPORTED_MODULE_1__/* .slugify */ .lV)(tag));
            });
            if (hasAllergiesFilterTag) return false;
            // loop over filter groups and check the filter
            var matchFilter = Object.keys(filterConfig).map(function(filterGroup) {
                return checkIfProductCorresponds(tagsMap[product.id], filterGroup, assignedFilter, filterConfig);
            });
            return matchFilter.every(function(checkedFilter) {
                return checkedFilter === true;
            });
        });
        return products;
    }, [
        activeAllergiesFilter,
        activeFilter,
        collection,
        filterConfig,
        segmentation,
        shouldOmitPersonalization,
        tagsMap, 
    ]);
    return visibleProducts;
};


/***/ }),

/***/ 38105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80969);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_product_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48457);
/* harmony import */ var components_product_card_skeleton_index___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49997);
/* harmony import */ var components_product_impressions_tracker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40321);
/* harmony import */ var constants_collection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93615);
/* harmony import */ var hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44621);
/* harmony import */ var modules_collection_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95961);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46066);
/* harmony import */ var tracking_events__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42659);
/* harmony import */ var tracking_gtm__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71295);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50453);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_13__);
















var SLIDES_TO_SHOW = {
    MOBILE: 1,
    MOBILE_BLOG: 2,
    DESKTOP: 4,
    DESKTOP_LARGE: 3
};
var MAX_PRODUCTS = {
    BLOG: 5,
    HOME: 6
};
var SKELETON_SLIDES = 5;
/**
 * Generic slider for collection.
 * @TODO : Name is misleading as it is a generic component with a different design from CollectionSection (with displayAsSlider on)
 */ var CollectionSectionBestseller = function(param) {
    var collection = param.collection, elementNameTracking = param.elementNameTracking, filterSubscriptionEnabledItems = param.filterSubscriptionEnabledItems, _isBlogPost = param.isBlogPost, isBlogPost = _isBlogPost === void 0 ? false : _isBlogPost, _isHomePage = param.isHomePage, isHomePage = _isHomePage === void 0 ? false : _isHomePage, lastSlide = param.lastSlide, _shouldShowLoading = param.shouldShowLoading, shouldShowLoading = _shouldShowLoading === void 0 ? false : _shouldShowLoading, sliderSize = param.sliderSize, staticCollection = param.staticCollection, swrOptions = param.swrOptions, onTileClick = param.onTileClick;
    var isMobile = (0,hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_8__.useState(0), 2), currentIndex = ref[0], setCurrentIndex = ref[1];
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (collection) {
            var ref;
            setCurrentIndex(0);
            (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(0);
        }
    }, [
        collection
    ]);
    var sliderProps = react__WEBPACK_IMPORTED_MODULE_8__.useMemo(function() {
        var variableWidth = isMobile && sliderSize === "large";
        var slidesToShow = SLIDES_TO_SHOW.DESKTOP;
        if (isMobile) {
            slidesToShow = isBlogPost ? SLIDES_TO_SHOW.MOBILE_BLOG : SLIDES_TO_SHOW.MOBILE;
        } else if (sliderSize === "large") {
            slidesToShow = SLIDES_TO_SHOW.DESKTOP_LARGE;
        }
        var centerMode = false;
        if (isMobile && isBlogPost) {
            centerMode = false;
        } else if (isMobile) {
            centerMode = true;
        }
        return {
            arrows: !isMobile,
            centerMode: centerMode,
            infinite: false,
            slidesToShow: slidesToShow,
            variableWidth: variableWidth
        };
    }, [
        isMobile,
        isBlogPost,
        sliderSize
    ]);
    var hasTrackedRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(false);
    var afterChange = function(index) {
        setCurrentIndex(index);
        if (!hasTrackedRef.current) {
            hasTrackedRef.current = true;
            (0,tracking_gtm__WEBPACK_IMPORTED_MODULE_11__/* .gtm */ .w)((0,tracking_events__WEBPACK_IMPORTED_MODULE_10__/* .scrollElement */ .qR)({
                element: [
                    "Collection Section Bestseller",
                    collection
                ]
            }));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_collection_state__WEBPACK_IMPORTED_MODULE_7__/* .CollectionProvider */ .YQ, {
        collection: staticCollection,
        collectionHandle: collection || "",
        sortBy: constants_collection__WEBPACK_IMPORTED_MODULE_5__/* .CollectionSorting.DEFAULT */ .I.DEFAULT,
        swrOptions: swrOptions,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_collection_state__WEBPACK_IMPORTED_MODULE_7__/* .CollectionContext.Consumer */ .WH.Consumer, {
            children: function(val) {
                if (shouldShowLoading && val.isValidating) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_13___default().slickContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            dots: false,
                            ref: sliderRef
                        }, sliderProps), {
                            children: new Array(SKELETON_SLIDES).fill(null).map(function(_, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "px-2 py-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_product_card_skeleton_index___WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        isSlider: true
                                    })
                                }, index);
                            })
                        }))
                    });
                }
                if (!val.collection) {
                    return "";
                }
                var products = val.collection.products.filter(function(p) {
                    return p.availableForSale;
                });
                var maxProducts = isBlogPost ? MAX_PRODUCTS.BLOG : isHomePage ? MAX_PRODUCTS.HOME : products.length;
                products = products.slice(0, maxProducts);
                var filteredProducts = filterSubscriptionEnabledItems ? products.filter(function(product) {
                    return product.tags.includes("SubscriptionEnabled");
                }) : products;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_style_module_css__WEBPACK_IMPORTED_MODULE_13___default().slickContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_slick__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                        afterChange: afterChange,
                        dots: false,
                        ref: sliderRef
                    }, sliderProps), {
                        children: [
                            filteredProducts.map(function(product, index) {
                                var ref;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_product_impressions_tracker__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    collectionHandle: collection,
                                    element: (ref = elementNameTracking && elementNameTracking[0]) !== null && ref !== void 0 ? ref : "Collection Section Bestseller",
                                    list: val.collection.title,
                                    position: index,
                                    product: product,
                                    trackingGroupName: collection,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-2 h-full", sliderSize === "large" && "w-[90%]"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_product_card__WEBPACK_IMPORTED_MODULE_2__["default"], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                            collectionTitle: val.collection.title,
                                            position: index,
                                            product: product,
                                            starSize: sliderSize === "large" || !isMobile ? "medium" : "small",
                                            type: sliderSize === "large" ? components_product_card__WEBPACK_IMPORTED_MODULE_2__.CARD_TYPES.SLIDER_LARGE : components_product_card__WEBPACK_IMPORTED_MODULE_2__.CARD_TYPES.SLIDER
                                        }, onTileClick ? {
                                            onTileClick: function() {
                                                onTileClick(product);
                                            }
                                        } : {}))
                                    })
                                }, "".concat(product.id, "-").concat(product.promoteVariantId));
                            }),
                            lastSlide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-full",
                                children: lastSlide
                            })
                        ]
                    }))
                });
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionSectionBestseller);


/***/ }),

/***/ 50453:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slickContainer":"style_slickContainer__LN9W3"};

/***/ })

}]);